var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductdesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "product_design",
    "data-name": "product design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.989,
    height: 70.775,
    viewBox: "0 0 73.989 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2451",
    "data-name": "Group 2451",
    transform: "translate(22.067 16.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M152,272h24.15v10.867H152Zm0,0",
    transform: "translate(-152 -251.473)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M360.15,174V162.3l-4.73-.786a20.117,20.117,0,0,0-.989-2.4l2.784-3.9-8.276-8.276-3.9,2.784a20.281,20.281,0,0,0-2.4-.989L341.854,144H336v12.075a12.075,12.075,0,0,1,0,24.15V192.3h5.854l.786-4.73a20.12,20.12,0,0,0,2.4-.989l3.9,2.784,8.276-8.276-2.784-3.9a20.274,20.274,0,0,0,.989-2.4Zm0,0",
    transform: "translate(-308.228 -142.792)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M216.9,152.9H200V136h16.9Zm0,0",
    transform: "translate(-192.755 -136)",
    fill: "#c5c5ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M59.908,43.378A12.659,12.659,0,0,0,57.1,35.432L55.35,36.88a10.3,10.3,0,0,1-6.746,16.7V51.278a7.991,7.991,0,0,0,0-15.8v-2.3a10.123,10.123,0,0,1,5.3,2.248l1.433-1.766A12.391,12.391,0,0,0,48.6,30.876V15.509L37.769,4.566H19.1a5.641,5.641,0,0,0-11.075,0H0V70.775H48.6v-14.9a12.521,12.521,0,0,0,11.3-12.5ZM38.431,8.463l6.314,6.377H38.431ZM53.126,43.378A5.7,5.7,0,0,1,48.6,48.971V37.786A5.7,5.7,0,0,1,53.126,43.378ZM13.564,54.794a3.412,3.412,0,0,1-3.391-3.425V46.8h6.782v4.566A3.412,3.412,0,0,1,13.564,54.794ZM16.955,44.52H10.173V19.406h6.782ZM13.564,2.283a3.412,3.412,0,0,1,3.391,3.425V17.123H10.173V5.708A3.412,3.412,0,0,1,13.564,2.283ZM2.261,68.492V6.849H7.912v44.52a5.7,5.7,0,0,0,4.521,5.592v2.4h2.261v-2.4a5.7,5.7,0,0,0,4.521-5.592V7.06a3.418,3.418,0,0,1,2.261,3.214V27.4A4.548,4.548,0,0,0,26,31.963V29.68A2.274,2.274,0,0,1,23.737,27.4V10.274a5.686,5.686,0,0,0-1.16-3.425H36.171V17.123H46.344V68.492Zm0,0",
    transform: "translate(3.214 0)",
    fill: "#3335cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M448,296h2.415v2.415H448Zm0,0",
    transform: "translate(-381.256 -253.845)",
    fill: "#3335cf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M409.539,209.543l1.707-1.707,1.708,1.707-1.708,1.708Zm0,0",
    transform: "translate(-348.6 -178.261)",
    fill: "#3335cf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M409.539,379.247l1.707-1.707,1.707,1.707-1.707,1.707Zm0,0",
    transform: "translate(-348.6 -323.817)",
    fill: "#3335cf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M58.116,385.921,56.4,378.186a2.794,2.794,0,0,0-5.377-.277L48.3,386.081a1.186,1.186,0,0,1-1.732.593l-2.18-1.452a4.69,4.69,0,0,0-5.774.572,3.694,3.694,0,0,1-2.594,1.074H32v2.415h4.017a6.039,6.039,0,0,0,4.3-1.782,2.223,2.223,0,0,1,2.727-.271l2.181,1.453a3.564,3.564,0,0,0,5.361-1.839l2.723-8.169a.393.393,0,0,1,.729.035l1.719,7.734a3.6,3.6,0,0,0,3.537,2.838H64.6v-2.415H59.294a1.2,1.2,0,0,1-1.177-.945Zm0,0",
    transform: "translate(-23.956 -323.337)",
    fill: "#ff7b00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M264,448h2.415v2.415H264Zm0,0",
    transform: "translate(-223.188 -384.47)",
    fill: "#ff7b00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M152,264h24.15v2.415H152Zm0,0",
    transform: "translate(-127.694 -226.402)",
    fill: "#ff7b00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M152,296h24.15v2.415H152Zm0,0",
    transform: "translate(-127.694 -253.845)",
    fill: "#ff7b00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M152,328h2.415v2.415H152Zm0,0",
    transform: "translate(-127.139 -281.287)",
    fill: "#ff7b00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M184,328h19.32v2.415H184Zm0,0",
    transform: "translate(-155.058 -281.287)",
    fill: "#ff7b00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M416,112h2.415v2.415H416Zm0,0",
    transform: "translate(-354.086 -96.049)",
    fill: "#3335cf"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M448,112h2.415v2.415H448Zm0,0",
    transform: "translate(-381.256 -96.049)",
    fill: "#3335cf"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M480,112h2.415v2.415H480Zm0,0",
    transform: "translate(-408.426 -96.049)",
    fill: "#3335cf"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M360,480h2.415v2.415H360Zm0,0",
    transform: "translate(-305.516 -411.64)",
    fill: "#3335cf"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M392,480h2.415v2.415H392Zm0,0",
    transform: "translate(-332.959 -411.64)",
    fill: "#3335cf"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M424,480h2.415v2.415H424Zm0,0",
    transform: "translate(-360.878 -411.64)",
    fill: "#3335cf"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M18.934,138.795a1.092,1.092,0,0,0,1.093-1.093v-1.093h1.093a1.093,1.093,0,0,0,0-2.185H20.026v-1.093a1.093,1.093,0,0,0-2.185,0v1.093H16.749a1.093,1.093,0,0,0,0,2.185h1.093V137.7A1.092,1.092,0,0,0,18.934,138.795Z",
    transform: "translate(49.362 -70.434)",
    fill: "#3335cf"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M143.656,6.987A2.749,2.749,0,1,0,146.4,4.239,2.752,2.752,0,0,0,143.656,6.987Zm3.665,0a.916.916,0,1,1-.916-.916A.917.917,0,0,1,147.321,6.987Z",
    transform: "translate(-143.656 7.88)",
    fill: "#ff7b00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductdesign);
export default __webpack_public_path__ + "static/media/product design.5638928be91a389be41d6d814bd3fc75.svg";
export { ForwardRef as ReactComponent };